import React from 'react';
import Proptypes from 'prop-types';
import { ComparedDateRangePicker } from '@bingads-webui-react/compared-date-range-picker';
import { today, specificRanges, i18nMock } from './date-range-config';
import { convertISOStringToCivilDate } from './date-range-utils';

export const DateRangePicker = (props) => {
  const {
    startDate,
    endDate,
    onPickDateRanges,
  } = props;

  const startCivilDate = startDate !== '' ? convertISOStringToCivilDate(startDate) : today.plus({ years: -1 });
  const endCivilDate = endDate !== '' ? convertISOStringToCivilDate(endDate) : today;

  return (
    <ComparedDateRangePicker
      i18n={i18nMock}
      disableCompare
      selectedRange={{ start: startCivilDate, end: endCivilDate }}
      specificRanges={specificRanges}
      onPickDateRanges={onPickDateRanges}
      minDate={today.plus({ years: -1 })}
      maxDate={today}
    />
  );
};

DateRangePicker.propTypes = {
  startDate: Proptypes.string,
  endDate: Proptypes.string,
  onPickDateRanges: Proptypes.func.isRequired,
};

DateRangePicker.defaultProps = {
  startDate: '',
  endDate: '',
};
